var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C1.792 0 0 1.792 0 4C0 6.208 1.792 8 4 8C6.208 8 8 6.208 8 4C8 1.792 6.208 0 4 0ZM2 4.6C1.668 4.6 1.4 4.332 1.4 4C1.4 3.668 1.668 3.4 2 3.4C2.332 3.4 2.6 3.668 2.6 4C2.6 4.332 2.332 4.6 2 4.6ZM4 4.6C3.668 4.6 3.4 4.332 3.4 4C3.4 3.668 3.668 3.4 4 3.4C4.332 3.4 4.6 3.668 4.6 4C4.6 4.332 4.332 4.6 4 4.6ZM6 4.6C5.668 4.6 5.4 4.332 5.4 4C5.4 3.668 5.668 3.4 6 3.4C6.332 3.4 6.6 3.668 6.6 4C6.6 4.332 6.332 4.6 6 4.6Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxPending);
export default __webpack_public_path__ + "static/media/tx-pending.3e7f3c22.svg";
export { ForwardRef as ReactComponent };